import React from 'react';
import {
    PopupContainer,
    EmptyCart,
    Text,
} from 'src/common/components/deleteOrderPopup/DeleteOrderPopup.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useTranslation } from 'react-i18next';
import { logErrorToConsole } from 'src/utils/util';

const DeleteOrderPopup = ({
    onDeleteClose,
    deleteOrderHandler,
    isOtherUser,
    message,
}) => {
    const { t } = useTranslation();
    return (
        <>
            <Popup
                title={message ? '' : t('orders.deleteDraftOrder.title')}
                onClose={onDeleteClose}
                id={'common-deleteOrderPopupDeleteButton-popup'}
            >
                <EmptyCart height={'117px'}>
                    <Text>
                        {message
                            ? message
                            : isOtherUser
                            ? t('orders.deleteDraftOrder.msg2')
                            : t('orders.deleteDraftOrder.msg1')}
                    </Text>
                    <PopupContainer
                        justifyContent={'center'}
                        position={'static'}
                        marginTop={'5px'}
                    >
                        <Button
                        id="deleteOrderPopupCancelButton"
                            show={true}
                            width={'130px'}
                            mobileWidth={'120px'}
                            height={'38px'}
                            //cancel={true}
                            variant={ButtonStyles?.cancel}
                            // borderRadius={'19px'}
                            margin={'5px 10px 0px 0px'}
                            fontSize={'13px'}
                            // fontFamily={'AvenirNextWorld Demi'}
                            clicked={onDeleteClose}
                        >
                            {message
                                ? t('common.cancelButton')
                                : t(
                                      'orders.deleteDraftOrder.buttonCancelLabel'
                                  )}
                        </Button>

                        <Button
                        id={'common-deleteOrderPopupDeleteButton'}
                            show={true}
                            width={'130px'}
                            mobileWidth={'120px'}
                            height={'38px'}
                            //primary={true}
                            variant={ButtonStyles?.primary}
                            // borderRadius={'19px'}
                            margin={'5px 0px 0px 0px'}
                            fontSize={'13px'}
                            // fontFamily={'AvenirNextWorld Demi'}
                            clicked={() => {
                                try {
                                    deleteOrderHandler();
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                            }}
                        >
                            {message
                                ? t('templates.deleteTemplate.delete')
                                : t(
                                      'orders.deleteDraftOrder.buttonDeleteLabel'
                                  )}
                        </Button>
                    </PopupContainer>
                </EmptyCart>
            </Popup>
        </>
    );
};

export default DeleteOrderPopup;
